import { Grid } from '@mui/material'
import { useField } from 'formik'
import { Carrier, CarrierCard } from './CarrierCard'

type Props = {
  name: string
  selectableCarriers: Carrier[]
}

export const CarrierInput = ({ name, selectableCarriers }: Props) => {
  const [field, , helpers] = useField(name)
  const size = selectableCarriers.length > 1 ? 6 : 12

  return (
    <Grid container wrap="nowrap" spacing={1} direction="row" alignItems="stretch">
      {selectableCarriers.map((carrier) => (
        <Grid size={{ xs: size }} key={carrier.key}>
          <CarrierCard
            carrier={carrier}
            isSelected={field.value === carrier.key}
            onClick={() => helpers.setValue(carrier.key)}
            showDescription={selectableCarriers.length <= 2}
          />
        </Grid>
      ))}
    </Grid>
  )
}
